<template>
    <div>
        <v-container>
            <div class="row">
                <div
                    class="col-md-3 col-sm-3 col-xs-12"
                >
                    <v-card outlined>
                        <v-card-title>Kategorie</v-card-title>
                        <v-divider></v-divider>
                        <template>
                            <v-treeview :items="categories" :selected-color="'#fff'" activatable open-on-click dense>
                                <template slot="label" slot-scope="props">
                                    <a :href="props.item.link">{{props.item.name}}</a>
                                </template>
                            </v-treeview>
                        </template>
                    </v-card>
                </div>
                <div
                    class="col-md-9 col-sm-9 col-xs-12"
                >
                    <v-breadcrumbs class="pb-0" :items="breadcrums"></v-breadcrumbs>
                    <div class="row text-center">
                        <div class="col-md-4 col-sm-6 col-xs-12" :key="product.id" v-for="product in products">
                            <v-hover v-slot:default="{ hover }">
                                <v-card
                                    class="mx-auto"
                                    color="grey lighten-4"
                                    max-width="600"
                                >
                                    <v-img
                                        class="white--text align-end"
                                        :aspect-ratio="16/9"
                                        height="300px"
                                        :src="require(`../assets/img/${product.img}`)"
                                    >
                                        <v-card-title>{{ product.category.name }}</v-card-title>
                                        <v-expand-transition>
                                            <div
                                                v-if="hover"
                                                class="d-flex transition-fast-in-fast-out white darken-2 v-card--reveal display-3 white--text"
                                                style="height: 100%;"
                                            >
                                                <v-btn v-if="hover" :href="`/produkt/${product.slug}`" class="" outlined>Zobacz</v-btn>
                                            </div>

                                        </v-expand-transition>
                                    </v-img>
                                    <v-card-text class="text--primary">
                                        <div><a :href="`/produkt/${product.id}`" style="text-decoration: none">{{ product.name }}</a></div>
                                        <div class="pricing">
                                            <div>Doba: {{ product.price.hours24 }}zł</div>
                                            <div>Tydzień: {{ product.price.days7 }}zł</div>
                                        </div>

                                    </v-card-text>
                                </v-card>
                            </v-hover>
                        </div>
                    </div>
<!--                    <div class="text-center mt-12">-->
<!--                        <v-pagination-->
<!--                            v-model="page"-->
<!--                            :length="6"-->
<!--                        ></v-pagination>-->
<!--                    </div>-->
                </div>
            </div>
        </v-container>
    </div>
</template>
<style>
.v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .8;
    position: absolute;
    width: 100%;
}
</style>
<script>

import products from '~/products/products.json'

export default {

    data: () => ({
        page: 1,
        breadcrums: [
            {
                text: 'Start',
                disabled: false,
                href: '/',
            }
        ],

       // products: products
    }),

    computed: {
        categories () {
            const key = 'name';
            const uniqueCategories = [...new Map(products.map(item =>
                [item.category[key], item.category])).values()];
            return uniqueCategories.map((category, i) => {
                return {
                    id: i,
                    name: category.name,
                    link: '/kategoria/' + category.slug
                }
            });
        },
        products() {
            if(this.$route.params.slug) {
                return products.filter((product) => product.category.slug === this.$route.params.slug);
                // return products.filter((product) => product.category.slug);
            }
            return products
        }
    }

}
</script>

<style scoped>
.pricing {
    display: flex;
    justify-content: space-between;
}

.v-card__text a {
    font-weight: bold;
}

/deep/ .v-responsive__content > .v-card__title {
    background-color: rgba(0, 0, 0, 0.5);
}
a {
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Shop.vue